<template>
  <div class="wg-col wg-xs-12" style="padding:2%;">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
      :confirmOnClose="true"
      :confirmOnCloseMsg="
        $anm22.strLang(lang, 'Discard changes?', 'Scartare le modifiche?')
      "
    >
      <div slot="header">
        <span>{{
          mode == "edit"
            ? $anm22.strLang(
                lang,
                "Edit",
                "Modifica " + currentMaterialList.name
              )
            : $anm22.strLang(lang, "New", "Nuovo")
        }}</span>
      </div>

      <div slot="body">
        <div v-show="tabToShow === 'default'">
          <span style="font-size:17px">{{
            $anm22.strLang(lang, "Model name", "Nome modello")
          }}</span>
          <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
          <div class="wg-col wg-xs-5">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="currentMaterialList.name"
            />
            <div class="vertical-height-div" style="height:12px;"></div>
          </div>
          <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
          <div class="wg-col wg-xs-5">
            <div
              style="font-size:17px;"
              class="com-anm22-app-text-m suit-model"
            >
              {{ $anm22.strLang(lang, "Items", "Articoli") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
          <div>
            <div v-if="currentMaterialList.materials.length == 0">
              {{ $anm22.strLang(lang, "Empty list", "Nessun articolo") }}
            </div>
            <div
              v-for="(material, index) in currentMaterialList.materials
                .materials"
              :key="index"
              class="material-item"
            >
              <input
                type="number"
                v-model="
                  currentMaterialList.materials.materials[index].quantity
                "
                step="0.1"
                class="qnt"
              />
              <div class="uom">
                {{ getProductUomLabelById(material.product) }}
              </div>
              <div class="product-name">
                {{ getProductNameById(material.product) }}
              </div>
              <img
                class="com-anm22-app-img-fixed-height-l delete-icon"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="removeItem(material.product)"
              />
            </div>
            <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
            <div class="items-btns">
              <div @click="tabToShow = 'addProduct'" class="add-product-btn">
                <span class="add-ic">+</span>
                {{ $anm22.strLang(lang, "Add item", "Aggiungi articolo") }}
              </div>
              <div @click="clearItems" class="clear-items-btn">
                <img
                  class="clear-ic"
                  :src="$anm22.icons.getWorldIcon('deleteBin')"
                />
                {{ $anm22.strLang(lang, "Clear items", "Svuota lista") }}
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Save', 'Salva')"
              @click="addMaterialList"
            />
          </div>
        </div>
        <div v-show="tabToShow === 'addProduct'">
          <div class="wg-col wg-xs-5">
            <div
              style="font-size:17px;"
              class="com-anm22-app-text-m suit-model"
            >
              {{ $anm22.strLang(lang, "Add item", "Aggiungi articolo") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
          <input
            type="search"
            v-model="productSearch"
            class="product-search-input"
          />
          <div class="products-list">
            <div class="wg-row product-row header">
              <div class="code">
                {{ $anm22.strLang(lang, "Code", "Codice") }}
              </div>
              <div class="name">{{ $anm22.strLang(lang, "Name", "Nome") }}</div>
              <div class="category">
                {{ $anm22.strLang(lang, "Category", "Categoria") }}
              </div>
            </div>
            <div
              v-for="(product, index) in filteredProducts"
              :key="index"
              @click="addItem(product.idWarehouseProduct)"
              class="product-row"
            >
              <div class="code">{{ product.code }}</div>
              <div class="name">{{ product.name }}</div>
              <div class="category">
                {{ getProductCategoryNameById(product.category) }}
              </div>
              <div class="color">
                <div
                  class="color-preview"
                  :title="product.colorString"
                  :style="{ 'background-color': product.colorString }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <div style="font-size:24px;" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Material lists", "Distinte base") }}
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div
      class="wg-row"
      style="height:49px;padding:5px;"
      v-for="(materialList, index) in materialLists"
      :key="index"
    >
      <span style="padding:11px;">{{ materialList.name }}</span>
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Edit', 'Modifica')"
        @click="selectMaterialList(materialList)"
      />
      <div class="com-anm22-horizontal-div" style="width: 10px;"></div>
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Clone', 'Duplica')"
        @click="cloneMaterialList(materialList.idVircosMaterialsList)"
      />
      <div class="com-anm22-horizontal-div" style="width: 10px;"></div>
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
        @click="removeMaterialList(materialList)"
      />
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add material list', 'Aggiungi distinta')"
        @click="add"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      materialLists: [],
      mode: "edit",
      openModal: false,
      currentMaterialList: {},
      tabToShow: "default",
      products: [],
      productCategories: [],
      productSearch: "",
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    filteredProducts() {
      return this.products.filter((product) => {
        if (this.productSearch) {
          const search = this.productSearch.toLowerCase();
          if (
            product.code.toLowerCase().includes(search) ||
            product.name.toLowerCase().includes(search)
          ) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
    },
  },
  methods: {
    loadData() {
      return this.$vlf("vircos-materials-lists")
        .getItems()
        .then((result) => {
          if (result) {
            this.materialLists = Object.values(result);
          }
        });
    },
    add() {
      this.currentMaterialList = {
        materials: {
          materials: [],
        },
      };
      this.mode = "new";
      this.tabToShow = "default";
      this.openModal = true;
    },
    addMaterialList() {
      this.$http
        .post(
          "vircos/materials-lists",
          {
            mode: this.mode,
            materialsList: this.currentMaterialList,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-materials-lists").setItem(
            String(response.data.materialsList.idVircosMaterialsList),
            response.data.materialsList
          );
          this.loadData();
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cloneMaterialList(materialListId) {
      this.$http
        .post(
          "vircos/materials-list-clone",
          {
            materialsListId: materialListId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          const materialList = response.data.materialsList;
          this.$vlf("vircos-materials-lists").setItem(
            String(materialList.idVircosMaterialsList),
            materialList
          );
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeMaterialList(materialList) {
      this.$http
        .post(
          "vircos/materials-list-remove",
          {
            materialsList: materialList,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-materials-lists")
            .removeItem(String(materialList.idVircosMaterialsList))
            .then((result) => {
              this.loadData();
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectMaterialList(materialList) {
      this.mode = "edit";
      this.tabToShow = "default";
      this.openModal = true;
      this.currentMaterialList = materialList;
    },
    closeModal() {
      this.openModal = false;
    },
    getProductById(productId) {
      let product = null;
      this.products.forEach(function(element) {
        if (element.idWarehouseProduct == productId) {
          product = element;
        }
      });
      return product;
    },
    getProductNameById(productId) {
      const product = this.getProductById(productId);
      if (product) {
        return product.name;
      } else {
        return "";
      }
    },
    getProductCategoryById(categoryId) {
      let categroy = null;
      this.productCategories.forEach(function(element) {
        if (element.idWarehouseCategory == categoryId) {
          categroy = element;
        }
      });
      return categroy;
    },
    getProductCategoryNameById(categoryId) {
      const category = this.getProductCategoryById(categoryId);
      if (category) {
        return category.name;
      } else {
        return "";
      }
    },
    getProductUomLabelById(productId) {
      const product = this.getProductById(productId);
      switch (product.uom) {
        case 1:
          return "kg";
        case 2:
          return "l";
        case 3:
          return "g";
        case 4:
          return "q";
        case 5:
          return "t";
        case 6:
          return "m";
        case 7:
          return "km";
        case 8:
          return "m²";
        case 9:
          return "m³";
        case 10:
          return "min";
        case 11:
          return "h";
        case 12:
          return "d";
        default:
          return "";
      }
    },
    loadWarehouseData() {
      this.$http
        .get("warehouse")
        .then((response) => {
          this.products = response.data.products;
          this.productCategories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addItem(productId) {
      const index = this.currentMaterialList.materials.materials
        .map((e) => e.product)
        .indexOf(productId);
      if (index >= 0) {
        this.currentMaterialList.materials.materials[index].quantity++;
      } else {
        this.currentMaterialList.materials.materials.push({
          quantity: 1,
          product: productId,
        });
      }
      this.tabToShow = "default";
    },
    removeItem(productId) {
      const index = this.currentMaterialList.materials.materials
        .map((e) => e.product)
        .indexOf(productId);
      if (index >= 0) {
        this.currentMaterialList.materials.materials.splice(index, 1);
      }
    },
    clearItems() {
      this.currentMaterialList.materials.materials = [];
    },
  },
  created() {
    this.loadData();
    this.$http
      .get("vircos/materials-lists")
      .then((response) => {
        const materialLists = response.data.materialsLists;
        //map per salvare nel db locale le distinte base
        materialLists.map((materialList) =>
          this.$vlf("vircos-materials-lists").setItem(
            String(materialList.idVircosMaterialsList),
            materialList
          )
        );
        this.loadData();
      })
      .catch((error) => {
        console.log(error);
      });
    this.loadWarehouseData();
  },
};
</script>

<style lang="scss" scoped>
.material-item {
  margin: 2px 0;
  display: flex;
  align-items: center;
  position: relative;

  .qnt {
    display: inline-block;
    vertical-align: middle;
    width: 70px;
    padding-left: 15px;
    padding-right: 25px;
    margin-right: 5px;
    position: relative;
    background-image: url("../../../../world/libs/anm22_icons/img/icons/delete.svg");
    background-repeat: no-repeat;
    background-position: 6px 15px;
    background-size: 6px 6px;
  }
  .product-name {
    flex: 1;
  }
  .uom {
    position: absolute;
    top: calc(50% - 5px);
    left: 50px;
    height: 10px;
    font-size: 10px;
  }
  .delete-icon {
    padding: 5px;
    display: inline-block;
    cursor: pointer;
  }
}

.products-list {
  overflow-x: auto;

  .product-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    display: flex;

    &:hover {
      background-color: #eeeeee;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.code {
        width: 25%;
        min-width: 60px;
      }
      &.name {
        width: 45%;
        min-width: 120px;
      }
      &.category {
        width: calc(30% - 42px);
        min-width: 120px;
      }
      &.color {
        width: 42px;

        .color-preview {
          border: 1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
    }

    &.header {
      cursor: default;
      div {
        font-weight: 600;
      }
    }
  }
}
.items-btns {
  display: flex;

  .add-product-btn,
  .clear-items-btn {
    cursor: pointer;
    flex: 1;
    text-align: center;

    .add-ic {
      color: #66bb6a;
      font-size: 24px;
      vertical-align: middle;
      margin-right: 5px;
    }

    .clear-ic {
      display: inline-block;
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin: 4px 5px 4px 0;
    }
  }
  .clear-items-btn {
    text-align: right;
  }
}
.product-search-input {
  width: 100%;
  max-width: 720px;
  min-height: 36px;
  background: rgba(0, 0, 0, 0.1);
  border: 0;
  border-radius: 8px;
  font-size: 16px;
  background-repeat: no-repeat;
  background-position: 10px 10px;
  background-size: 16px 16px;
  line-height: 1;
  box-sizing: border-box;
  padding: 0 10px 0 36px;
  margin: 0;
  outline: 0;
  background-image: url("data:image/png;base64,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");
}
</style>
